var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "readmore readmore__linkBox",
          class: {
            "readmore__linkBox--arrow-left": _vm.arrowLeft,
            "readmore__linkBox--arrow-down": _vm.arrowDown,
            "readmore__linkBox--arrow-up": _vm.arrowUp,
            "readmore__linkBox--disabled": _vm.isDisabled,
            "readmore__linkBox--muted": _vm.muted,
            "readmore__linkBox--green": _vm.colour === "green",
            "readmore__linkBox--red": _vm.colour === "red",
          },
          attrs: { href: "#", target: "_self" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.doButtonAction.apply(null, arguments)
            },
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c("span")]
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c("popup-modal", {
            attrs: {
              heading: _vm.confirmationHeading,
              message: _vm.confirmationMessage,
            },
            on: { close: _vm.handleCloseModal, confirm: _vm.handleConfirm },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }